<div class="filter-panel">
  <div class="filter-panel__body">
    <div class="panel-header">
      <img src="assets/icon/Filter.svg" alt="" />
      <span class="title">{{ 'TREEVIEW.FILTRER' | translate }}</span>
    </div>

    <div class="filter-item">
      <label class="toggle-switch">
        <input type="checkbox" [checked]="store.holesEnabled()" (change)="store.toggleHoles()" />
        <span class="slider"></span>
      </label>
      <img src="assets/icon/Holes.svg" alt="" />
      <span class="filter-label">{{ 'GLOBAL.TROUS' | translate }}</span>
    </div>

    @for (option of polygonOptions; track option.type) {
      <div class="filter-item">
        <label class="toggle-switch">
          <input type="checkbox" [checked]="store.polygonTypes().includes(option.type)" (change)="store.togglePolygonType(option.type)" />
          <span class="slider"></span>
        </label>
        <img [src]="option.icon" alt="" />
        <span class="filter-label">{{ option.label }}</span>
      </div>
    }

    <div class="filter-item">
      <label class="toggle-switch">
        <input type="checkbox" [checked]="store.orthophotosVisible()" (change)="store.toggleOrthophotos()" />
        <span class="slider"></span>
      </label>
      <img src="assets/icon/ortho.svg" alt="" />
      <span class="filter-label">Ortho</span>
    </div>

    <div class="filter-item">
      <label class="toggle-switch">
        <input type="checkbox" [checked]="store.controlPointsVisible()" (change)="store.toggleControlPoints()" />
        <span class="slider"></span>
      </label>
      <img src="assets/icon/control-point-black.svg" alt="" />
      <span class="filter-label">Control points</span>
    </div>

    <div class="filter-item">
      <label class="toggle-switch">
        <input type="checkbox" [checked]="store.zonesOfInterestVisible()" (change)="store.toggleZonesOfInterest()" />
        <span class="slider"></span>
      </label>
      <img src="assets/icon/Polygon_right.svg" alt="" />
      <span class="filter-label">{{ 'ZOI.ZONE' | translate }}</span>
    </div>
  </div>
</div>
